'use strict';

(function () {
  angular
    .module('specsguardApp')
    .directive('sgElementLogItem', sgElementLogItem);

  sgElementLogItem.$inject = ['sgElementItems'];

  function sgElementLogItem (sgElementItems) {
    return {
      templateUrl: 'app-legacy/components/sg-element-items/sg-element-log-item.tmpl.html',
      transclude: true,
      scope: {
        item: '=',
        labels: '=',
        setFullName: '&'
      },
      link: function ($scope) {
        $scope.fullName = (item) => sgElementItems.setFullName(item);
      }
    };
  }
})();
